import { isAllNao } from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta07Model,
  ConsultaSeguimentoPergunta07OlharParaEnum,
} from './model-consultaSeguimentoPergunta07'

const pergunta07OlharParaEnumValues = Object.values(ConsultaSeguimentoPergunta07OlharParaEnum)

export const isPergunta07OlharParaAllNao = (
  value: ConsultaSeguimentoPergunta07Model['PERGUNTA_07_OLHAR_PARA']
): boolean => {
  return isAllNao(value, pergunta07OlharParaEnumValues)
}
